import { gql } from "@apollo/client";

export const GET_TIP_ITEMS = gql`
  query GetTipItems {
    getTipItems {
      id
      name
      emoji
      price
      description
      isActive
    }
  }
`;

export const GET_WALLET_BALANCE = gql`
  query GetWalletBalance($staffId: ID, $businessId: ID) {
    getPlanyCoinWallet(staffId: $staffId, businessId: $businessId) {
      balance
    }
  }
`;

export const GET_WALLET_SUMMARY = gql`
  query GetWalletSummary($staffId: ID, $businessId: ID) {
    getWalletSummary(staffId: $staffId, businessId: $businessId) {
      totalPurchased
      totalSpent
      tipsReceived
      tipsSent
      balance
    }
  }
`;

export const GET_COIN_TRANSACTIONS = gql`
  query GetPlanyCoinTransactions($staffId: ID, $businessId: ID) {
    getPlanyCoinTransactions(staffId: $staffId, businessId: $businessId) {
      id
      staff {
        id
        user {
          id
          username
        }
      }
      targetStaff {
        id
        user {
          id
          username
        }
      }
      targetBusiness {
        id
        name
      }
      type
      amount
      usdValue
      item
      note
      createdAt
    }
  }
`;

export const WITHDRAW_PLANY_COINS = gql`
  mutation WithdrawPlanyCoins($amount: Int!) {
    withdrawPlanyCoins(amount: $amount) {
      success # true if backend processed the withdrawal
      message # any error or confirmation text
    }
  }
`;

export const GET_COIN_CONFIG = gql`
  query GetCoinConfig {
    getCoinConfig {
      purchaseRate
      redemptionRate
      packs { coins price }
      minWithdrawal
    }
  }
`;